import { AppDispatch } from "@/app/stores";
import { useDispatch } from "react-redux";

export const useAppDispatch: () => AppDispatch = useDispatch